export function logSagaErrorMessage(action?: string, e?: unknown) {
	console.warn(`> Failed ${action}: `, (e as any) as Error);
}
